import React from "react";
//MUI Components
import LinearProgress from "@mui/material/LinearProgress";
import { DataGrid } from "@mui/x-data-grid";
//Custom Components
import PanelButtonGestion from "../../../components/Button/PanelButtonGestion";
import PagePaper from "../../../components/Paper/PagePaper";
import GridListProductCard from "../../../components/Cards/ProductCard/GridListProductCard";

//Functions
import { Outlet } from "react-router";
import { useData } from "../../../lib/context/DataContext";
import ButtonMenuSettings from "../../../components/Button/ButtonMenuSettings";

export default function GestionProduits() {
	const { produits } = useData();

	const [affichageData, setAffichageData] = React.useState("table");

	const handleAffichageData = (_, newValue) => {
		if (newValue !== null) setAffichageData(newValue);
	};

	const columns = [
		{ field: "categorie", headerName: "Catégorie", flex: 0.4 },
		{ field: "name", headerName: "Nom", flex: 2 },
		{ field: "unite", headerName: "Unité", flex: 0.4 },
		{ field: "prix", headerName: "Prix €/Kg", flex: 0.4 },
		{
			field: "actions",
			headerName: "",
			sortable: false,
			filterable: false,
			flex: 0.4,
			disableColumnMenu: true,
			renderCell: (params) => (
				<ButtonMenuSettings
					type="produit"
					id={params.id}
				/>
			),
		},
	];

	return (
		<PagePaper name="Gestion des produits">
			<PanelButtonGestion
				name="Ajouter un produit"
				color="info"
				link={"./ajouter_produit"}
				handleAffichageData={handleAffichageData}
				affichageData={affichageData}
			/>
			<Outlet />
			{(produits.loading || produits.error) && (
				<LinearProgress
					variant="indeterminate"
					color="info"
				/>
			)}
			{produits.data &&
				(affichageData === "table" ? (
					<DataGrid
						rows={produits.data}
						columns={columns}
						getRowId={(row) => row.rowKey}
						density="compact"
						initialState={{
							pagination: {
								paginationModel: {
									pageSize: 10,
								},
							},
						}}
						pageSizeOptions={[5, 10, 20, 30]}
						disableRowSelectionOnClick
						sx={{
							bgcolor: "white",
							"& .MuiDataGrid-columnHeader": {
								bgcolor: "info.light",
								color: "white",
							},
						}}
					/>
				) : (
					affichageData === "grid" && (
						<GridListProductCard
							products={produits.data}
							type={"showroom"}
							isEditable={true}
						/>
					)
				))}
		</PagePaper>
	);
}
